interface IconProps {
  size?: number;
  className?: string;
}

export function Clock({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 4.5V8l2.5 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Check({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M3 8l3.5 3.5L13 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Cross({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function Plus({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function Camera({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <rect x="1.5" y="4.5" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="8" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M5.5 4.5l1-2h3l1 2" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

export function ArrowUR({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M4 12L12 4M6 4h6v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Warning({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M8 2L14.5 13.5H1.5L8 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 6.5v3M8 11v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function Bell({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M8 2a4 4 0 00-4 4v2.5L2.5 10h11L12 8.5V6a4 4 0 00-4-4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6.5 12a1.5 1.5 0 003 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

// ── Extended icons (added FTR-997 Task 2) ─────────────────────────────────────

export function Flame({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12 2c1.5 3 4 4.5 4 8a4 4 0 11-8 0c0-1 .3-1.6.8-2.3-.2 2 .7 2.8 1.7 2.8.5-2.5-1-4 1.5-8.5zm0 20a6 6 0 006-6c0-3-2-5-3-7-.5 3-2 4-3 4s-2-.5-2-2c-2 1.5-4 3-4 6a6 6 0 006 5z" />
    </svg>
  );
}

export function CardIcon({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M3 7.5A2.5 2.5 0 015.5 5h13A2.5 2.5 0 0121 7.5V9H3V7.5zM3 11h18v5.5a2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 013 16.5V11zm3 4a1 1 0 011-1h3a1 1 0 110 2H7a1 1 0 01-1-1z" />
    </svg>
  );
}

export function TagIcon({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M3 4.5A1.5 1.5 0 014.5 3h6.7c.4 0 .8.16 1.06.44l8.3 8.3a1.5 1.5 0 010 2.12l-6.7 6.7a1.5 1.5 0 01-2.12 0l-8.3-8.3A1.5 1.5 0 013 11.2V4.5zM7.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
    </svg>
  );
}

export function Chart({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M4 20a1 1 0 01-1-1V8a1 1 0 011-1h2a1 1 0 011 1v11a1 1 0 01-1 1H4zm7 0a1 1 0 01-1-1V4a1 1 0 011-1h2a1 1 0 011 1v15a1 1 0 01-1 1h-2zm7 0a1 1 0 01-1-1v-7a1 1 0 011-1h2a1 1 0 011 1v7a1 1 0 01-1 1h-2z" />
    </svg>
  );
}

export function Question({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M12 22a10 10 0 100-20 10 10 0 000 20zM9.5 9a2.5 2.5 0 015 0c0 .9-.5 1.4-1.4 2-.7.5-1.1.8-1.1 1.5v.5a1 1 0 102 0v-.4c0-.2.2-.4.7-.7 1-.7 1.8-1.5 1.8-2.9a4.5 4.5 0 10-9 0 1 1 0 102 0zM12 17a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z" />
    </svg>
  );
}

export function Doc({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M5 4.5A2.5 2.5 0 017.5 2h6.6c.4 0 .78.16 1.06.44l4.4 4.4c.28.28.44.66.44 1.06V19.5a2.5 2.5 0 01-2.5 2.5h-10A2.5 2.5 0 015 19.5v-15zm9 1V8a1 1 0 001 1h2.5L14 5.5zM7.5 12a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zm1 3a1 1 0 100 2h7a1 1 0 100-2h-7z" />
    </svg>
  );
}

export function Lock({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M7 9V7a5 5 0 1110 0v2h.5A2.5 2.5 0 0120 11.5v8a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 014 19.5v-8A2.5 2.5 0 016.5 9H7zm2 0V7a3 3 0 116 0v2H9z" />
    </svg>
  );
}

export function ChevR({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Xmark({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
